export default "__VITE_ASSET__BnQywwur__"